import styled from 'styled-components';
import { position } from 'polished';
import { fromLarge, fromMedium } from 'styleUtils/mediaQueries';

const XPositionXl = '15%',
    XPositionL = '20%';
export const Wrapper = styled.div`
    display: none;
    ${fromMedium`
    display: block;
    transform: translateX(-50%);
    ${position('absolute', '212px', null, null, XPositionL)}
  `};
    ${fromLarge`
    display: block;
    transform: translateX(-50%);
    ${position('absolute', '84px', null, null, XPositionXl)}
  `}
    z-index: 2;
`;
